import React from 'react'
var BlumeLogo = require('../Media/BlumeLockup.svg');
export default function Blume8() {
  return (
    <>
      <img src={BlumeLogo} alt="blume-logo"/>
    </>
  )
}
